import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import Form from "react-bootstrap/Form";
import Collapse from "react-bootstrap/Collapse";
import Select from "react-select";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { Formik } from "formik";
import * as yup from "yup";
// import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { AutoTabProvider } from "react-auto-tab";
import { ThailandAddressTypeahead, ThailandAddressValue } from "react-thailand-address-typeahead";
import DataTableLayout from "layouts/DatatableLayout";
import DownloadExcel from "utils/DownloadExcel";
import { nanoid } from "nanoid";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { getAllMstPrefix } from "../../redux/handlers/master/getAllMstPrefix.handler";
import { getAllMstSex } from "../../redux/handlers/master/getAllMstSex.handler";
import { getAllMstDepartment } from "../../redux/handlers/master/getAllMstDepartment.handler";
import { getAllMstMaritalStatus } from "../../redux/handlers/master/getAllMstMaritalStatus.handler";
import { getAllMstMilitaryStatus } from "../../redux/handlers/master/getAllMstMilitaryStatus.handler";
import { getAllMstPosition } from "../../redux/handlers/master/getAllMstPosition.handler";
import { getAllMstBank } from "../../redux/handlers/master/getAllMstBank.handler";
import { getAllMstBankAccountType } from "../../redux/handlers/master/getAllMstBankAccountType.handler";
import { getAllMstRelationship } from "../../redux/handlers/master/getAllMstRelationship.handler";
import { getAllMstEmployeeDoc } from "../../redux/handlers/master/getAllMstEmployeeDoc.handler";
import { getAllMstEmployeeType } from "../../redux/handlers/master/getAllMstEmployeeType.handler";
import { base64ToBlob, generateRandomString, mapMstToOptions } from "utils/HelperFunction";
import { defaultOption } from "constants/ui/options";
import { getAllNewAlldernowEmp } from "../../redux/handlers/logic/getAllNewAlldernowEmp.handler";
import { useGlobalSelectedBranchContext } from "contexts/GlobalSelectedBranchContext";
import { getNewAlldernowEmpById } from "../../redux/handlers/logic/getNewAlldernowEmpById.handler";
import { clearUpdateNewAlldernowEmp, updateNewAlldernowEmp } from "../../redux/handlers/logic/updateNewAlldernowEmp.handler";
import { clearCreateNewAlldernowEmp, createNewAlldernowEmp } from "../../redux/handlers/logic/createNewAlldernowEmp.handler";
import moment from "moment";
import { getFileName, getFullUrlPath } from "utils/HandleFileFunction";
import { initialState } from "mocks/empData";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
export function Emp() {
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useGlobalSelectedBranchContext = useGlobalSelectedBranchContext(), selectedBranchId = _useGlobalSelectedBranchContext.selectedBranchId, setSelectedBranchId = _useGlobalSelectedBranchContext.setSelectedBranchId;
    var _useState = _sliced_to_array(useState([]), 2), empdata = _useState[0], setEmpdata = _useState[1];
    var _useState1 = _sliced_to_array(useState([]), 2), empCanceldata = _useState1[0], setEmpCanceldata = _useState1[1];
    var _useState2 = _sliced_to_array(useState([]), 2), empActiveData = _useState2[0], setEmpActiveData = _useState2[1];
    var _useState3 = _sliced_to_array(useState([]), 2), empAlldata = _useState3[0], setEmpAlldata = _useState3[1];
    var _useState4 = _sliced_to_array(useState({
        value: "",
        label: "ทั้งหมด"
    }), 2), position = _useState4[0], setPosition = _useState4[1];
    var _useState5 = _sliced_to_array(useState({
        value: "",
        label: "ทั้งหมด"
    }), 2), department = _useState5[0], setDepartment = _useState5[1];
    var getAllNewAlldernowEmpReducer = useAppSelector(function(state) {
        return state.getAllNewAlldernowEmpReducer;
    });
    var getAllMstDepartmentReducer = useAppSelector(function(state) {
        return state.getAllMstDepartmentReducer;
    });
    var getAllMstPositionReducer = useAppSelector(function(state) {
        return state.getAllMstPositionReducer;
    });
    var getempData = function() {
        dispatch(getAllNewAlldernowEmp({
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    var loadAllMsts = function() {
        dispatch(getAllMstDepartment());
        dispatch(getAllMstPosition());
    };
    var _useState6 = _sliced_to_array(useState([]), 2), optionsMstDepartment = _useState6[0], setOptionsMstDepartment = _useState6[1];
    var _useState7 = _sliced_to_array(useState([]), 2), optionsMstPosition = _useState7[0], setOptionsMstPosition = _useState7[1];
    useEffect(function() {
        getempData();
        loadAllMsts();
    }, []);
    useEffect(function() {
        setIsLoading(getAllMstPositionReducer.isFetching || getAllMstDepartmentReducer.isFetching || getAllNewAlldernowEmpReducer.isFetching);
        if (getAllMstPositionReducer.data) {
            var options = mapMstToOptions(getAllMstPositionReducer.data.data);
            setOptionsMstPosition([
                defaultOption
            ].concat(_to_consumable_array(options)));
        }
        if (getAllMstDepartmentReducer.data) {
            var options1 = mapMstToOptions(getAllMstDepartmentReducer.data.data);
            setOptionsMstDepartment([
                defaultOption
            ].concat(_to_consumable_array(options1)));
        }
        if (getAllNewAlldernowEmpReducer.data) {
            var result = getAllNewAlldernowEmpReducer.data.data;
            setEmpAlldata(result);
            var empCancel = result.filter(function(emp) {
                return emp.end_date !== null && emp.dim_branch_id === selectedBranchId;
            });
            var empActive = result.filter(function(emp) {
                return emp.end_date === null && emp.dim_branch_id === selectedBranchId;
            });
            setEmpdata(empActive);
            setEmpActiveData(empActive);
            setEmpCanceldata(empCancel);
        }
    }, [
        getAllMstPositionReducer,
        getAllMstDepartmentReducer,
        getAllNewAlldernowEmpReducer
    ]);
    useEffect(function() {
        var empActive = empAlldata.filter(function(emp) {
            return emp.end_date === null && emp.dim_branch_id === selectedBranchId;
        });
        var empCancel = empAlldata.filter(function(emp) {
            return emp.end_date !== null && emp.dim_branch_id === selectedBranchId;
        });
        setEmpdata(empActive);
        setEmpActiveData(empActive);
        setEmpCanceldata(empCancel);
    }, [
        selectedBranchId
    ]);
    var columns = [
        {
            name: "รหัสพนักงาน",
            selector: function(row) {
                return row.emp_code;
            },
            width: "150px",
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx("div", {
                    style: {
                        color: "#565DFF",
                        fontWeight: 500
                    },
                    children: /*#__PURE__*/ _jsx(Link, {
                        className: " me-2",
                        to: "/emps/edit/" + row.id,
                        children: row.emp_code
                    })
                });
            }
        },
        {
            name: "รูปพนักงาน",
            selector: function(row) {
                return row.img_path;
            },
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx("div", {
                    style: {
                        color: "#565DFF",
                        fontWeight: 500
                    },
                    children: /*#__PURE__*/ _jsx("img", {
                        src: row.img_path ? getFullUrlPath(row.img_path) : "",
                        className: "imgprofile"
                    })
                });
            },
            center: "true"
        },
        {
            name: "ชื่อพนักงาน (ชื่อเล่น)",
            selector: function(row) {
                return row.first_name_th;
            },
            cell: function(row, index, column, id) /*#__PURE__*/ {
                var _row_dimMstPrefix;
                var _row_nick_name;
                return _jsxs("div", {
                    children: [
                        (_row_dimMstPrefix = row.dimMstPrefix) === null || _row_dimMstPrefix === void 0 ? void 0 : _row_dimMstPrefix.name,
                        " ",
                        row.first_name_th,
                        " ",
                        row.last_name_th,
                        " (",
                        " ",
                        (_row_nick_name = row.nick_name) !== null && _row_nick_name !== void 0 ? _row_nick_name : "-",
                        " )"
                    ]
                });
            }
        },
        {
            name: "แผนก",
            selector: function(row) {
                return row.dimMstDepartment ? row.dimMstDepartment.name : "-";
            }
        },
        {
            name: "ตำแหน่ง",
            selector: function(row) {
                return row.dimMstPosition;
            },
            cell: function(row, index, column, id) {
                return row.dimMstPosition && row.dimMstPosition.name == "เจ้าของธุรกิจ" ? /*#__PURE__*/ _jsx("div", {
                    className: "py-1 px-3",
                    style: {
                        color: "#565DFF",
                        background: "#EEF4FF",
                        borderRadius: "8px"
                    },
                    children: row.name
                }) : /*#__PURE__*/ _jsx("div", {
                    className: "ps-3",
                    children: row.dimMstPosition ? row.dimMstPosition.name : "-"
                });
            }
        },
        {
            name: "เบอร์โทร",
            selector: function(row) {
                return row.phone_number ? row.phone_number : "-";
            }
        },
        {
            name: "E-MAIL",
            selector: function(row) {
                return row.email ? row.email : "-";
            }
        },
        {
            name: "สถานะ",
            selector: function(row) {
                return row.dimMstEmployeeType;
            },
            center: "true",
            width: "180px",
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1",
                    style: {
                        color: "rgba(114, 225, 40, 0.87)",
                        backgroundColor: "rgba(238, 251, 229, 1)",
                        borderRadius: "20px"
                    },
                    children: row.dimMstEmployeeType ? row.dimMstEmployeeType.name : "ยังไม่ตั้งค่า"
                });
            }
        }
    ];
    var _useState8 = _sliced_to_array(useState(""), 2), filterText = _useState8[0], setFilterText = _useState8[1];
    var filteredItems = empdata.filter(function(item) {
        return item.emp_code && item.emp_code.toLowerCase().includes(filterText.toLowerCase()) || item.first_name_th && item.first_name_th.toLowerCase().includes(filterText.toLowerCase()) || item.email && item.email.toLowerCase().includes(filterText.toLowerCase());
    });
    if (position.value != "") {
        filteredItems = filteredItems.filter(function(item) {
            return item.dim_mst_position_id == position.value;
        });
    }
    if (department.value != "") {
        filteredItems = filteredItems.filter(function(item) {
            return item.dim_mst_department_id == department.value;
        });
    }
    var _useState9 = _sliced_to_array(useState(1), 2), btnempstatus = _useState9[0], setBtnempstatus = _useState9[1];
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-2",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: "breadcrumb fs-16 ps-0 mb-1",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item ",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "บุคคล"
                                    })
                                }),
                                /*#__PURE__*/ _jsxs("li", {
                                    className: "breadcrumb-item active tc-1 ",
                                    "aria-current": "page",
                                    children: [
                                        " ",
                                        "รายชื่อพนักงาน",
                                        " "
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "mb-2",
                        children: [
                            /*#__PURE__*/ _jsxs(Button, {
                                type: "button",
                                className: btnempstatus == 1 ? "btn-category px-4 active" : "btn-category px-4",
                                onClick: function() {
                                    setBtnempstatus(1);
                                    var empActive = empAlldata.filter(function(emp) {
                                        return emp.end_date === null && emp.dim_branch_id === selectedBranchId;
                                    });
                                    setEmpdata(empActive);
                                    setEmpActiveData(empActive);
                                },
                                children: [
                                    "พนักงานทั้งหมด (",
                                    /*#__PURE__*/ _jsx("span", {
                                        children: empActiveData.length
                                    }),
                                    ")"
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Button, {
                                type: "button",
                                className: btnempstatus == 0 ? "btn-category px-4 active" : "btn-category px-4",
                                onClick: function() {
                                    setBtnempstatus(0);
                                    setEmpdata(empCanceldata);
                                },
                                children: [
                                    "พนักงานที่ลาออก (",
                                    /*#__PURE__*/ _jsx("span", {
                                        children: empCanceldata.length
                                    }),
                                    ")",
                                    " "
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "card card-st-2",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "card-body px-0 pt-4 pb-0",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "d-flex align-items-center px-4 mb-3 flex-wrap",
                            children: [
                                /*#__PURE__*/ _jsx(DownloadExcel, {
                                    data: empdata,
                                    filename: "รายชื่อพนักงาน"
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "mb-2 me-3",
                                    style: {
                                        width: "140px"
                                    },
                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                        className: "form-st-3 sm pb-1",
                                        children: [
                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                className: "mb-1",
                                                children: "แผนก"
                                            }),
                                            /*#__PURE__*/ _jsx(Select, {
                                                as: "select",
                                                name: "",
                                                onChange: function(e) {
                                                    setDepartment(e);
                                                },
                                                className: "w-100 select-st-1",
                                                options: optionsMstDepartment,
                                                placeholder: "เลือกแผนก",
                                                value: department
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "mb-2  me-3",
                                    style: {
                                        width: "140px"
                                    },
                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                        className: "mb-2 form-st-3 sm pb-1 ",
                                        children: [
                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                className: "mb-1",
                                                children: "ตำแหน่ง"
                                            }),
                                            /*#__PURE__*/ _jsx(Select, {
                                                as: "select",
                                                name: "",
                                                onChange: function(e) {
                                                    setPosition(e);
                                                },
                                                className: "w-100 select-st-1",
                                                options: optionsMstPosition,
                                                placeholder: "เลือกตำแหน่ง",
                                                value: position
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "me-3 mb-2",
                                    children: /*#__PURE__*/ _jsx("input", {
                                        type: "text",
                                        className: "form-control form-st-4",
                                        placeholder: "ค้นหาชื่อ, ชื่อเล่น, รหัสพนักงาน, เบอร์โทร",
                                        onKeyUp: function(e) {
                                            return setFilterText(e.target.value);
                                        }
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Link, {
                                    to: "/emps/create",
                                    className: "btn btn btn-st-7 mb-2 px-4",
                                    children: "เพิ่มพนักงาน"
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(DataTableLayout, {
                            item: filteredItems,
                            columns: columns,
                            isSelectRows: true,
                            PerPage: 10
                        })
                    ]
                })
            })
        ]
    });
}
export function EmpCreate() {
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useGlobalSelectedBranchContext = useGlobalSelectedBranchContext(), selectedBranchId = _useGlobalSelectedBranchContext.selectedBranchId, setSelectedBranchId = _useGlobalSelectedBranchContext.setSelectedBranchId;
    var empID = useParams().empID;
    var _useState = _sliced_to_array(useState(false), 2), modalcancel = _useState[0], setModalcancel = _useState[1];
    var _useState1 = _sliced_to_array(useState(false), 2), modalsuccess = _useState1[0], setModalsuccess = _useState1[1];
    var _useState2 = _sliced_to_array(useState(false), 2), textsuccess = _useState2[0], setTextsuccess = _useState2[1];
    var _useState3 = _sliced_to_array(useState(false), 2), modalconfirmcancelemp = _useState3[0], setModalconfirmcancelemp = _useState3[1];
    var schema = yup.object().shape({
        emp_code: yup.string().required(),
        first_name_th: yup.string().required(),
        last_name_th: yup.string().required(),
        first_name_en: yup.string().required(),
        last_name_en: yup.string().required(),
        address: yup.string().required()
    });
    var _useState4 = _sliced_to_array(useState(false), 2), formdisabled = _useState4[0], setFormdisabled = _useState4[1];
    var _useState5 = _sliced_to_array(useState(initialState), 2), formdata = _useState5[0], setFormdata = _useState5[1];
    var _useState6 = _sliced_to_array(useState(true), 2), cardOpen1 = _useState6[0], setCardOpen1 = _useState6[1];
    var _useState7 = _sliced_to_array(useState(true), 2), cardOpen2 = _useState7[0], setCardOpen2 = _useState7[1];
    var _useState8 = _sliced_to_array(useState(true), 2), cardOpen3 = _useState8[0], setCardOpen3 = _useState8[1];
    var _useState9 = _sliced_to_array(useState(true), 2), cardOpen4 = _useState9[0], setCardOpen4 = _useState9[1];
    var _useState10 = _sliced_to_array(useState(true), 2), cardOpen5 = _useState10[0], setCardOpen5 = _useState10[1];
    var _useState11 = _sliced_to_array(useState(""), 2), startDate = _useState11[0], setStartDate = _useState11[1];
    // const [branchselected, setBranchselected] = useState([]);
    var _useState12 = _sliced_to_array(useState([
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        ""
    ]), 2), identitycard = _useState12[0], setIdentitycard = _useState12[1];
    var handleinputTab = function(e, index) {
        var updateItem = _to_consumable_array(identitycard);
        updateItem[index] = e.target.value;
        setIdentitycard(updateItem);
    };
    var _useState13 = _sliced_to_array(useState(ThailandAddressValue.fromDatasourceItem({
        d: "",
        p: "",
        po: "",
        s: ""
    })), 2), address = _useState13[0], setAddress = _useState13[1];
    var _useState14 = _sliced_to_array(useState([]), 2), documents = _useState14[0], setDocuments = _useState14[1];
    var addDocument = function() {
        var newId = nanoid();
        setDocuments(function(doc) {
            return _to_consumable_array(doc).concat([
                {
                    id: newId,
                    docId: "",
                    docType: "",
                    docFile: "",
                    docFileType: "",
                    docFileData: "",
                    docUrl: ""
                }
            ]);
        });
    };
    var deleteDocument = function(removeId) {
        setDocuments(function(doc) {
            return doc.filter(function(item) {
                return item.id !== removeId;
            });
        });
    };
    var getempEditData = function(id) {
        dispatch(getNewAlldernowEmpById(id, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    useEffect(function() {
        if (empID) {
            getempEditData(empID);
        }
    }, [
        empID
    ]);
    var getAllMstPrefixReducer = useAppSelector(function(state) {
        return state.getAllMstPrefixReducer;
    });
    var getAllMstSexReducer = useAppSelector(function(state) {
        return state.getAllMstSexReducer;
    });
    var getAllMstMaritalStatusReducer = useAppSelector(function(state) {
        return state.getAllMstMaritalStatusReducer;
    });
    var getAllMstMilitaryStatusReducer = useAppSelector(function(state) {
        return state.getAllMstMilitaryStatusReducer;
    });
    var getAllMstRelationshipReducer = useAppSelector(function(state) {
        return state.getAllMstRelationshipReducer;
    });
    var getAllMstEmployeeTypeReducer = useAppSelector(function(state) {
        return state.getAllMstEmployeeTypeReducer;
    });
    var getAllMstDepartmentReducer = useAppSelector(function(state) {
        return state.getAllMstDepartmentReducer;
    });
    var getAllMstPositionReducer = useAppSelector(function(state) {
        return state.getAllMstPositionReducer;
    });
    var getAllMstBankReducer = useAppSelector(function(state) {
        return state.getAllMstBankReducer;
    });
    var getAllMstBankAccountTypeReducer = useAppSelector(function(state) {
        return state.getAllMstBankAccountTypeReducer;
    });
    var getAllMstEmployeeDocReducer = useAppSelector(function(state) {
        return state.getAllMstEmployeeDocReducer;
    });
    var getNewAlldernowEmpByIdReducer = useAppSelector(function(state) {
        return state.getNewAlldernowEmpByIdReducer;
    });
    var loadAllMsts = function() {
        dispatch(getAllMstPrefix());
        dispatch(getAllMstSex());
        dispatch(getAllMstMaritalStatus());
        dispatch(getAllMstMilitaryStatus());
        dispatch(getAllMstEmployeeType());
        dispatch(getAllMstDepartment());
        dispatch(getAllMstPosition());
        dispatch(getAllMstBank());
        dispatch(getAllMstBankAccountType());
        dispatch(getAllMstRelationship());
        dispatch(getAllMstEmployeeDoc());
    };
    var _useState15 = _sliced_to_array(useState([]), 2), optionsMstPrefix = _useState15[0], setOptionsMstPrefix = _useState15[1];
    var _useState16 = _sliced_to_array(useState([]), 2), optionsMstSex = _useState16[0], setOptionsMstSex = _useState16[1];
    var _useState17 = _sliced_to_array(useState([]), 2), optionsMstMaritalStatus = _useState17[0], setOptionsMstMaritalStatus = _useState17[1];
    var _useState18 = _sliced_to_array(useState([]), 2), optionsMstMilitaryStatus = _useState18[0], setOptionsMstMilitaryStatus = _useState18[1];
    var _useState19 = _sliced_to_array(useState([]), 2), optionsMstEmployeeType = _useState19[0], setOptionsMstEmployeeType = _useState19[1];
    var _useState20 = _sliced_to_array(useState([]), 2), optionsMstDepartment = _useState20[0], setOptionsMstDepartment = _useState20[1];
    var _useState21 = _sliced_to_array(useState([]), 2), optionsMstPosition = _useState21[0], setOptionsMstPosition = _useState21[1];
    var _useState22 = _sliced_to_array(useState([]), 2), optionsMstBank = _useState22[0], setOptionsMstBank = _useState22[1];
    var _useState23 = _sliced_to_array(useState([]), 2), optionsMstBankAccountType = _useState23[0], setOptionsMstBankAccountType = _useState23[1];
    var _useState24 = _sliced_to_array(useState([]), 2), optionsMstRelationship = _useState24[0], setOptionsMstRelationship = _useState24[1];
    var _useState25 = _sliced_to_array(useState([]), 2), optionsMstEmployeeDoc = _useState25[0], setOptionsMstEmployeeDoc = _useState25[1];
    useEffect(function() {
        loadAllMsts();
    }, []);
    useEffect(function() {
        setIsLoading(getAllMstPrefixReducer.isFetching || getAllMstSexReducer.isFetching || getAllMstMaritalStatusReducer.isFetching || getAllMstMilitaryStatusReducer.isFetching || getAllMstDepartmentReducer.isFetching || getAllMstPositionReducer.isFetching || getAllMstBankReducer.isFetching || getAllMstBankAccountTypeReducer.isFetching || getAllMstRelationshipReducer.isFetching || getAllMstEmployeeDocReducer.isFetching || getAllMstEmployeeTypeReducer.isFetching);
        if (getAllMstPrefixReducer.data) {
            setOptionsMstPrefix(getAllMstPrefixReducer.data.data.map(function(item) {
                return {
                    label: item.name,
                    value: item.id
                };
            }));
        }
        if (getAllMstSexReducer.data) {
            setOptionsMstSex(getAllMstSexReducer.data.data.map(function(item) {
                return {
                    label: item.name,
                    value: item.id
                };
            }));
        }
        if (getAllMstMaritalStatusReducer.data) {
            setOptionsMstMaritalStatus(getAllMstMaritalStatusReducer.data.data.map(function(item) {
                return {
                    label: item.name,
                    value: item.id
                };
            }));
        }
        if (getAllMstMilitaryStatusReducer.data) {
            setOptionsMstMilitaryStatus(getAllMstMilitaryStatusReducer.data.data.map(function(item) {
                return {
                    label: item.name,
                    value: item.id
                };
            }));
        }
        if (getAllMstEmployeeTypeReducer.data) {
            setOptionsMstEmployeeType(getAllMstEmployeeTypeReducer.data.data.map(function(item) {
                return {
                    label: item.name,
                    value: item.id
                };
            }));
        }
        if (getAllMstDepartmentReducer.data) {
            setOptionsMstDepartment(getAllMstDepartmentReducer.data.data.map(function(item) {
                return {
                    label: item.name,
                    value: item.id
                };
            }));
        }
        if (getAllMstPositionReducer.data) {
            setOptionsMstPosition(getAllMstPositionReducer.data.data.map(function(item) {
                return {
                    label: item.name,
                    value: item.id
                };
            }));
        }
        if (getAllMstBankReducer.data) {
            setOptionsMstBank(getAllMstBankReducer.data.data.map(function(item) {
                return {
                    label: item.name,
                    value: item.id
                };
            }));
        }
        if (getAllMstBankAccountTypeReducer.data) {
            setOptionsMstBankAccountType(getAllMstBankAccountTypeReducer.data.data.map(function(item) {
                return {
                    label: item.name,
                    value: item.id
                };
            }));
        }
        if (getAllMstRelationshipReducer.data) {
            setOptionsMstRelationship(getAllMstRelationshipReducer.data.data.map(function(item) {
                return {
                    label: item.name,
                    value: item.id
                };
            }));
        }
        if (getAllMstEmployeeDocReducer.data) {
            setOptionsMstEmployeeDoc(getAllMstEmployeeDocReducer.data.data.map(function(item) {
                return {
                    label: item.name,
                    value: item.id
                };
            }));
        }
    }, [
        getAllMstPrefixReducer,
        getAllMstSexReducer,
        getAllMstMaritalStatusReducer,
        getAllMstMilitaryStatusReducer,
        getAllMstEmployeeTypeReducer,
        getAllMstDepartmentReducer,
        getAllMstPositionReducer,
        getAllMstBankReducer,
        getAllMstBankAccountTypeReducer,
        getAllMstRelationshipReducer,
        getAllMstEmployeeDocReducer
    ]);
    var createNewAlldernowEmpReducer = useAppSelector(function(state) {
        return state.createNewAlldernowEmpReducer;
    });
    var updateNewAlldernowEmpReducer = useAppSelector(function(state) {
        return state.updateNewAlldernowEmpReducer;
    });
    var _useState26 = _sliced_to_array(useState([]), 2), updateDocIds = _useState26[0], setUpdateDocIds = _useState26[1];
    useEffect(function() {
        setIsLoading(createNewAlldernowEmpReducer.isFetching);
        if (createNewAlldernowEmpReducer.data && !createNewAlldernowEmpReducer.isError) {
            setTextsuccess("เพิ่มพนักงานสำเร็จ");
            setModalsuccess(true);
            setFormdisabled(true);
            dispatch(clearCreateNewAlldernowEmp());
        }
    }, [
        createNewAlldernowEmpReducer
    ]);
    useEffect(function() {
        setIsLoading(updateNewAlldernowEmpReducer.isFetching);
        if (updateNewAlldernowEmpReducer.data && !updateNewAlldernowEmpReducer.isError) {
            setTextsuccess("แก้ไขพนักงานสำเร็จ");
            setModalsuccess(true);
            setFormdisabled(true);
            dispatch(clearUpdateNewAlldernowEmp());
        }
    }, [
        updateNewAlldernowEmpReducer
    ]);
    useEffect(function() {
        setIsLoading(getNewAlldernowEmpByIdReducer.isFetching);
        if (empID && getNewAlldernowEmpByIdReducer.data) {
            var empEdit = getNewAlldernowEmpByIdReducer.data.data;
            if (!empEdit) {
                return navigate("/404", {
                    replace: true
                });
            }
            var empEditWithReplacements = Object.entries(empEdit).reduce(function(acc, param) {
                var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
                acc[key] = value === null ? "" : value;
                return acc;
            }, {});
            setFormdata(_object_spread({}, empEditWithReplacements));
        }
    }, [
        getNewAlldernowEmpByIdReducer
    ]);
    // handle form reinit
    useEffect(function() {
        if (empID) {
            setAddress({
                district: formdata.district,
                subdistrict: formdata.sub_district,
                province: formdata.province,
                postalCode: formdata.postal_code
            });
            setSelectedBranchId(formdata.dim_branch_id);
            setFormdisabled(true);
            setIdentitycard(formdata.id_card ? formdata.id_card : "");
            var docFiles = [];
            if (formdata.dimEmployeeAttachedDocs) {
                var _formdata_dimEmployeeAttachedDocs;
                docFiles = (_formdata_dimEmployeeAttachedDocs = formdata.dimEmployeeAttachedDocs) === null || _formdata_dimEmployeeAttachedDocs === void 0 ? void 0 : _formdata_dimEmployeeAttachedDocs.map(function(item) {
                    var newId = nanoid();
                    return {
                        id: newId,
                        docId: item.id,
                        docType: item.dim_mst_employee_doc_id,
                        docFile: getFileName(item.file_path),
                        docFileType: "",
                        docFileData: "",
                        docUrl: getFullUrlPath(item.file_path)
                    };
                });
            }
            setDocuments(docFiles);
        }
    }, [
        formdata
    ]);
    useEffect(function() {
        if (empID) {
            var deleteCandidateDocIds = formdata.dimEmployeeAttachedDocs ? formdata.dimEmployeeAttachedDocs.map(function(item) {
                return item.id;
            }) : [];
            var deleteDocIds = deleteCandidateDocIds.filter(function(docId) {
                return !documents.some(function(doc) {
                    return doc.docId === docId;
                });
            });
            var allDocIds = _to_consumable_array(deleteDocIds);
            console.log("All Doc IDs to update or delete:", allDocIds);
            setUpdateDocIds(allDocIds);
        }
    }, [
        empID,
        documents
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsx("nav", {
                "aria-label": "breadcrumb",
                className: "mt-2",
                children: /*#__PURE__*/ _jsxs("ol", {
                    className: "breadcrumb fs-16 ps-0 mb-1",
                    children: [
                        /*#__PURE__*/ _jsx("li", {
                            className: "breadcrumb-item",
                            children: /*#__PURE__*/ _jsx("a", {
                                href: "#",
                                className: "tc-7  text-decoration-none",
                                children: "บุคคล"
                            })
                        }),
                        /*#__PURE__*/ _jsxs("li", {
                            className: "breadcrumb-item active tc-1 ",
                            "aria-current": "page",
                            children: [
                                "รายชื่อพนักงาน",
                                " "
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Formik, {
                enableReinitialize: true,
                initialValues: formdata,
                validationSchema: schema,
                onSubmit: function(values) {
                    var _loop = function(key) {
                        if (Object.hasOwnProperty.call(values, key)) {
                            var value = values[key];
                            if (key === "dim_employee_attached_doc" && value) {
                                formdataPayload.append(key, JSON.stringify(value));
                            } else if (key === "update_doc_types" && value) {
                                formdataPayload.append(key, JSON.stringify(value));
                            } else if (key === "img_file" && typeof value === "string" && value) {
                                var blob = base64ToBlob(value);
                                formdataPayload.append(key, blob, "img_file.jpg");
                            } else if (key === "doc_files" && Array.isArray(value)) {
                                value.forEach(function(base64String, index) {
                                    if (base64String) {
                                        var blob = base64ToBlob(base64String);
                                        formdataPayload.append("".concat(key), blob, "document_".concat(index, ".pdf"));
                                    }
                                });
                            } else if (Array.isArray(value)) {
                                value.forEach(function(item) {
                                    return formdataPayload.append(key, item);
                                });
                            } else if (value !== undefined && value !== "") {
                                formdataPayload.append(key, value);
                            }
                        }
                    };
                    var formdataPayload = new FormData();
                    for(var key in values)_loop(key);
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = formdataPayload.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var pair = _step.value;
                            var _pair__name;
                            console.log("".concat(pair[0], ", ").concat((_pair__name = pair[1].name) !== null && _pair__name !== void 0 ? _pair__name : pair[1]));
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    if (empID) {
                        dispatch(updateNewAlldernowEmp(empID, formdataPayload, {
                            modalObj: modalObj,
                            setModalObj: setModalObj
                        }));
                    } else {
                        dispatch(createNewAlldernowEmp(formdataPayload, {
                            modalObj: modalObj,
                            setModalObj: setModalObj
                        }));
                    }
                },
                children: function(param) {
                    var handleSubmit = param.handleSubmit, handleChange = param.handleChange, touched = param.touched, errors = param.errors, values = param.values, setFieldValue = param.setFieldValue, isInvalid = param.isInvalid, isValid = param.isValid;
                    var _values_canceledUser_dimNewAlldernowEmp, _values_canceledUser_dimNewAlldernowEmp1;
                    return /*#__PURE__*/ _jsxs(Form, {
                        noValidate: true,
                        onSubmit: function(e) {
                            e.preventDefault();
                            var tx = "";
                            for(var i = 0; i < identitycard.length; i++){
                                tx += identitycard[i];
                            }
                            setFieldValue("id_card", tx);
                            setFieldValue("dim_employee_attached_doc", documents.filter(function(v) {
                                return !v.docId;
                            }).map(function(v) {
                                return {
                                    dim_mst_employee_doc_id: v.docType
                                };
                            }));
                            setFieldValue("doc_files", documents.map(function(v) {
                                return v.docFileData;
                            }));
                            setFieldValue("update_doc_types", documents.filter(function(v) {
                                return v.docId;
                            }).map(function(v) {
                                return {
                                    id: v.docId,
                                    dim_mst_employee_doc_id: v.docType
                                };
                            }));
                            setFieldValue("dim_branch_id", selectedBranchId);
                            setFieldValue("update_doc_ids", updateDocIds);
                            // console.log(values);
                            handleSubmit();
                        },
                        children: [
                            /*#__PURE__*/ _jsxs("fieldset", {
                                disabled: formdisabled,
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "card card-st-3 mb-3",
                                        children: /*#__PURE__*/ _jsxs("div", {
                                            className: "card-body px-xl-3",
                                            children: [
                                                /*#__PURE__*/ _jsx("button", {
                                                    type: "button",
                                                    className: "btn w-100 text-start btn-collapse",
                                                    onClick: function() {
                                                        return setCardOpen1(!cardOpen1);
                                                    },
                                                    "aria-controls": "collapse1",
                                                    "aria-expanded": cardOpen1,
                                                    children: /*#__PURE__*/ _jsx("div", {
                                                        className: "tc-8  fs-18 fw-bold px-3",
                                                        children: "ข้อมูลทั่วไป"
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx(Collapse, {
                                                    in: cardOpen1,
                                                    children: /*#__PURE__*/ _jsxs("div", {
                                                        id: "collapse1",
                                                        children: [
                                                            values.canceledUser && values.end_date ? /*#__PURE__*/ _jsx("div", {
                                                                className: "d-flex flex-wrap align-items-center align-items-center px-3 mt-4",
                                                                children: /*#__PURE__*/ _jsxs("div", {
                                                                    className: "me-3 alert-st-1",
                                                                    children: [
                                                                        "พนักงานลาออกไปเมื่อวันที่",
                                                                        " ",
                                                                        moment(values.end_date).format("DD/MM/YYYY"),
                                                                        " โดย",
                                                                        " ",
                                                                        (_values_canceledUser_dimNewAlldernowEmp = values.canceledUser.dimNewAlldernowEmp) === null || _values_canceledUser_dimNewAlldernowEmp === void 0 ? void 0 : _values_canceledUser_dimNewAlldernowEmp.first_name_th,
                                                                        " ",
                                                                        (_values_canceledUser_dimNewAlldernowEmp1 = values.canceledUser.dimNewAlldernowEmp) === null || _values_canceledUser_dimNewAlldernowEmp1 === void 0 ? void 0 : _values_canceledUser_dimNewAlldernowEmp1.last_name_th
                                                                    ]
                                                                })
                                                            }) : "",
                                                            /*#__PURE__*/ _jsxs("div", {
                                                                children: [
                                                                    /*#__PURE__*/ _jsx(Imageupload, {
                                                                        isUpdate: empID != undefined,
                                                                        setFieldValue: setFieldValue,
                                                                        values: values
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "pt-3 px-3",
                                                                        children: /*#__PURE__*/ _jsxs("div", {
                                                                            className: "row gx-xl-4",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx("div", {
                                                                                    className: "col-xl-3 col-md-6",
                                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                        className: "mb-2 form-st-3 pb-1",
                                                                                        children: [
                                                                                            /*#__PURE__*/ _jsxs(Form.Label, {
                                                                                                className: "mb-1",
                                                                                                children: [
                                                                                                    "รหัสพนักงาน",
                                                                                                    " ",
                                                                                                    /*#__PURE__*/ _jsx("span", {
                                                                                                        className: "text-danger ms-1",
                                                                                                        children: " *"
                                                                                                    }),
                                                                                                    " "
                                                                                                ]
                                                                                            }),
                                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                                type: "text",
                                                                                                name: "emp_code",
                                                                                                className: "form-control",
                                                                                                placeholder: "รหัสพนักงาน",
                                                                                                value: values.emp_code,
                                                                                                onChange: handleChange,
                                                                                                isInvalid: !!errors.emp_code
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ _jsx("div", {
                                                                                    className: "col-xl-3 col-md-6",
                                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                        className: "mb-2 form-st-3 pb-1",
                                                                                        children: [
                                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                                className: "mb-1",
                                                                                                children: "คำนำหน้า"
                                                                                            }),
                                                                                            /*#__PURE__*/ _jsx(Select, {
                                                                                                as: "select",
                                                                                                name: "dim_mst_prefix_id",
                                                                                                onChange: function(e) {
                                                                                                    setFieldValue("dim_mst_prefix_id", e.value);
                                                                                                },
                                                                                                className: "w-100 select-st-1",
                                                                                                options: optionsMstPrefix,
                                                                                                placeholder: "เลือกคำนำหน้า",
                                                                                                value: optionsMstPrefix.filter(function(item) {
                                                                                                    return item.value === values.dim_mst_prefix_id;
                                                                                                })
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ _jsx("div", {
                                                                                    className: "col-xl-3 col-md-6",
                                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                        className: "mb-2 form-st-3 pb-1",
                                                                                        children: [
                                                                                            /*#__PURE__*/ _jsxs(Form.Label, {
                                                                                                className: "mb-1",
                                                                                                children: [
                                                                                                    "ชื่อ (TH)",
                                                                                                    " ",
                                                                                                    /*#__PURE__*/ _jsx("span", {
                                                                                                        className: "text-danger ms-1",
                                                                                                        children: " *"
                                                                                                    })
                                                                                                ]
                                                                                            }),
                                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                                type: "text",
                                                                                                name: "first_name_th",
                                                                                                className: "form-control",
                                                                                                placeholder: "กรอกชื่อภาษาไทย",
                                                                                                value: values.first_name_th,
                                                                                                onChange: handleChange,
                                                                                                isInvalid: !!errors.first_name_th
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ _jsx("div", {
                                                                                    className: "col-xl-3 col-md-6",
                                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                        className: "mb-2 form-st-3 pb-1",
                                                                                        children: [
                                                                                            /*#__PURE__*/ _jsxs(Form.Label, {
                                                                                                className: "mb-1",
                                                                                                children: [
                                                                                                    "นามสกุล (TH)",
                                                                                                    " ",
                                                                                                    /*#__PURE__*/ _jsx("span", {
                                                                                                        className: "text-danger ms-1",
                                                                                                        children: " *"
                                                                                                    })
                                                                                                ]
                                                                                            }),
                                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                                type: "text",
                                                                                                name: "last_name_th",
                                                                                                className: "form-control",
                                                                                                placeholder: "กรอกนามสกุลภาษาไทย",
                                                                                                value: values.last_name_th,
                                                                                                onChange: handleChange,
                                                                                                isInvalid: !!errors.last_name_th
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ _jsx("div", {
                                                                                    className: "col-xl-3 col-md-6",
                                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                        className: "mb-2 form-st-3 pb-1",
                                                                                        children: [
                                                                                            /*#__PURE__*/ _jsxs(Form.Label, {
                                                                                                className: "mb-1",
                                                                                                children: [
                                                                                                    "ชื่อ (EN)",
                                                                                                    " ",
                                                                                                    /*#__PURE__*/ _jsx("span", {
                                                                                                        className: "text-danger ms-1",
                                                                                                        children: " *"
                                                                                                    })
                                                                                                ]
                                                                                            }),
                                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                                type: "text",
                                                                                                name: "first_name_en",
                                                                                                className: "form-control",
                                                                                                placeholder: "กรอกชื่อภาษาอังกฤษ",
                                                                                                value: values.first_name_en,
                                                                                                onChange: handleChange,
                                                                                                isInvalid: !!errors.first_name_en
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ _jsx("div", {
                                                                                    className: "col-xl-3 col-md-6",
                                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                        className: "mb-2 form-st-3 pb-1",
                                                                                        children: [
                                                                                            /*#__PURE__*/ _jsxs(Form.Label, {
                                                                                                className: "mb-1",
                                                                                                children: [
                                                                                                    "นามสกุล (EN)",
                                                                                                    " ",
                                                                                                    /*#__PURE__*/ _jsx("span", {
                                                                                                        className: "text-danger ms-1",
                                                                                                        children: " *"
                                                                                                    })
                                                                                                ]
                                                                                            }),
                                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                                type: "text",
                                                                                                name: "last_name_en",
                                                                                                className: "form-control",
                                                                                                placeholder: "กรอกนามสกุลภาษาอังกฤษ",
                                                                                                value: values.last_name_en,
                                                                                                onChange: handleChange,
                                                                                                isInvalid: !!errors.last_name_en
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ _jsxs("div", {
                                                                                    className: "col-xl-6 col-md-12",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                                            className: "mb-1 tc-10  fs-12",
                                                                                            children: "หมายเลขบัตรประชาชน (13 หลัก)"
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsx("div", {
                                                                                            className: "my-0 form-st-3 identitycard ",
                                                                                            children: /*#__PURE__*/ _jsxs(AutoTabProvider, {
                                                                                                children: [
                                                                                                    /*#__PURE__*/ _jsx("span", {
                                                                                                        children: /*#__PURE__*/ _jsx("input", {
                                                                                                            type: "text",
                                                                                                            settings: {
                                                                                                                placement: 1
                                                                                                            },
                                                                                                            maxLength: 1,
                                                                                                            tabbable: "true",
                                                                                                            defaultValue: identitycard[0],
                                                                                                            className: "form-tab first",
                                                                                                            onChange: function(e) {
                                                                                                                return handleinputTab(e, 0);
                                                                                                            }
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsxs("span", {
                                                                                                        children: [
                                                                                                            /*#__PURE__*/ _jsx("input", {
                                                                                                                type: "text",
                                                                                                                settings: {
                                                                                                                    placement: 2
                                                                                                                },
                                                                                                                maxLength: 1,
                                                                                                                tabbable: "true",
                                                                                                                defaultValue: identitycard[1],
                                                                                                                className: "form-tab",
                                                                                                                onChange: function(e) {
                                                                                                                    return handleinputTab(e, 1);
                                                                                                                }
                                                                                                            }),
                                                                                                            /*#__PURE__*/ _jsx("input", {
                                                                                                                type: "text",
                                                                                                                settings: {
                                                                                                                    placement: 3
                                                                                                                },
                                                                                                                maxLength: 1,
                                                                                                                tabbable: "true",
                                                                                                                defaultValue: identitycard[2],
                                                                                                                className: "form-tab",
                                                                                                                onChange: function(e) {
                                                                                                                    return handleinputTab(e, 2);
                                                                                                                }
                                                                                                            }),
                                                                                                            /*#__PURE__*/ _jsx("input", {
                                                                                                                type: "text",
                                                                                                                settings: {
                                                                                                                    placement: 4
                                                                                                                },
                                                                                                                maxLength: 1,
                                                                                                                tabbable: "true",
                                                                                                                defaultValue: identitycard[3],
                                                                                                                className: "form-tab",
                                                                                                                onChange: function(e) {
                                                                                                                    return handleinputTab(e, 3);
                                                                                                                }
                                                                                                            }),
                                                                                                            /*#__PURE__*/ _jsx("input", {
                                                                                                                type: "text",
                                                                                                                settings: {
                                                                                                                    placement: 5
                                                                                                                },
                                                                                                                maxLength: 1,
                                                                                                                tabbable: "true",
                                                                                                                defaultValue: identitycard[4],
                                                                                                                className: "form-tab",
                                                                                                                onChange: function(e) {
                                                                                                                    return handleinputTab(e, 4);
                                                                                                                }
                                                                                                            })
                                                                                                        ]
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsxs("span", {
                                                                                                        children: [
                                                                                                            /*#__PURE__*/ _jsx("input", {
                                                                                                                type: "text",
                                                                                                                settings: {
                                                                                                                    placement: 6
                                                                                                                },
                                                                                                                maxLength: 1,
                                                                                                                tabbable: "true",
                                                                                                                defaultValue: identitycard[5],
                                                                                                                className: "form-tab",
                                                                                                                onChange: function(e) {
                                                                                                                    return handleinputTab(e, 5);
                                                                                                                }
                                                                                                            }),
                                                                                                            /*#__PURE__*/ _jsx("input", {
                                                                                                                type: "text",
                                                                                                                settings: {
                                                                                                                    placement: 7
                                                                                                                },
                                                                                                                maxLength: 1,
                                                                                                                tabbable: "true",
                                                                                                                defaultValue: identitycard[6],
                                                                                                                className: "form-tab",
                                                                                                                onChange: function(e) {
                                                                                                                    return handleinputTab(e, 6);
                                                                                                                }
                                                                                                            }),
                                                                                                            /*#__PURE__*/ _jsx("input", {
                                                                                                                type: "text",
                                                                                                                settings: {
                                                                                                                    placement: 8
                                                                                                                },
                                                                                                                maxLength: 1,
                                                                                                                tabbable: "true",
                                                                                                                defaultValue: identitycard[7],
                                                                                                                className: "form-tab",
                                                                                                                onChange: function(e) {
                                                                                                                    return handleinputTab(e, 7);
                                                                                                                }
                                                                                                            }),
                                                                                                            /*#__PURE__*/ _jsx("input", {
                                                                                                                type: "text",
                                                                                                                settings: {
                                                                                                                    placement: 9
                                                                                                                },
                                                                                                                maxLength: 1,
                                                                                                                tabbable: "true",
                                                                                                                defaultValue: identitycard[8],
                                                                                                                className: "form-tab",
                                                                                                                onChange: function(e) {
                                                                                                                    return handleinputTab(e, 8);
                                                                                                                }
                                                                                                            }),
                                                                                                            /*#__PURE__*/ _jsx("input", {
                                                                                                                type: "text",
                                                                                                                settings: {
                                                                                                                    placement: 10
                                                                                                                },
                                                                                                                maxLength: 1,
                                                                                                                tabbable: "true",
                                                                                                                defaultValue: identitycard[9],
                                                                                                                className: "form-tab",
                                                                                                                onChange: function(e) {
                                                                                                                    return handleinputTab(e, 9);
                                                                                                                }
                                                                                                            })
                                                                                                        ]
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsxs("span", {
                                                                                                        children: [
                                                                                                            /*#__PURE__*/ _jsx("input", {
                                                                                                                type: "text",
                                                                                                                settings: {
                                                                                                                    placement: 11
                                                                                                                },
                                                                                                                maxLength: 1,
                                                                                                                tabbable: "true",
                                                                                                                defaultValue: identitycard[10],
                                                                                                                className: "form-tab",
                                                                                                                onChange: function(e) {
                                                                                                                    return handleinputTab(e, 10);
                                                                                                                }
                                                                                                            }),
                                                                                                            /*#__PURE__*/ _jsx("input", {
                                                                                                                type: "text",
                                                                                                                settings: {
                                                                                                                    placement: 12
                                                                                                                },
                                                                                                                maxLength: 1,
                                                                                                                tabbable: "true",
                                                                                                                defaultValue: identitycard[11],
                                                                                                                className: "form-tab",
                                                                                                                onChange: function(e) {
                                                                                                                    return handleinputTab(e, 11);
                                                                                                                }
                                                                                                            }),
                                                                                                            /*#__PURE__*/ _jsx("input", {
                                                                                                                type: "text",
                                                                                                                settings: {
                                                                                                                    placement: 13
                                                                                                                },
                                                                                                                maxLength: 1,
                                                                                                                tabbable: "true",
                                                                                                                defaultValue: identitycard[12],
                                                                                                                className: "form-tab",
                                                                                                                onChange: function(e) {
                                                                                                                    return handleinputTab(e, 12);
                                                                                                                }
                                                                                                            })
                                                                                                        ]
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ _jsx("div", {
                                                                                    className: "col-xl-3 col-md-6",
                                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                        className: "mb-2 form-st-3 pb-1",
                                                                                        children: [
                                                                                            /*#__PURE__*/ _jsxs(Form.Label, {
                                                                                                className: "mb-1",
                                                                                                children: [
                                                                                                    "ชื่อเล่น",
                                                                                                    " "
                                                                                                ]
                                                                                            }),
                                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                                type: "text",
                                                                                                name: "nick_name",
                                                                                                className: "form-control",
                                                                                                placeholder: "กรอกชื่อเล่น",
                                                                                                value: values.nick_name,
                                                                                                onChange: handleChange,
                                                                                                isInvalid: !!errors.nick_name
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ _jsx("div", {
                                                                                    className: "col-xl-3 col-md-6",
                                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                        className: "mb-2 form-st-3 pb-1",
                                                                                        children: [
                                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                                className: "mb-1",
                                                                                                children: "เพศ"
                                                                                            }),
                                                                                            /*#__PURE__*/ _jsx(Select, {
                                                                                                as: "select",
                                                                                                name: "dim_mst_sex_id",
                                                                                                onChange: function(e) {
                                                                                                    setFieldValue("dim_mst_sex_id", e.value);
                                                                                                },
                                                                                                className: "w-100 select-st-1",
                                                                                                options: optionsMstSex,
                                                                                                placeholder: "เพศ",
                                                                                                value: optionsMstSex.filter(function(item) {
                                                                                                    return item.value === values.dim_mst_sex_id;
                                                                                                })
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ _jsx("div", {
                                                                                    className: "col-xl-3 col-md-6",
                                                                                    children: /*#__PURE__*/ _jsx(Form.Group, {
                                                                                        className: "mt-[12px]",
                                                                                        children: /*#__PURE__*/ _jsx(LocalizationProvider, {
                                                                                            dateAdapter: AdapterDayjs,
                                                                                            className: "h-[40px]",
                                                                                            children: /*#__PURE__*/ _jsx(DatePicker, {
                                                                                                /* disabled={!values.isEditing} */ format: "DD/MM/YYYY",
                                                                                                slotProps: {
                                                                                                    textField: {
                                                                                                        InputLabelProps: {
                                                                                                            shrink: true
                                                                                                        },
                                                                                                        error: !!errors.birth_date
                                                                                                    }
                                                                                                },
                                                                                                label: "วันเกิด",
                                                                                                className: "h-[40px] w-full",
                                                                                                sx: {
                                                                                                    ".MuiInputBase-formControl": {
                                                                                                        height: "53px",
                                                                                                        borderRadius: "8px"
                                                                                                    },
                                                                                                    ".MuiFormLabel-root": {
                                                                                                        fontFamily: "Sarabun"
                                                                                                    },
                                                                                                    ".MuiOutlinedInput-notchedOutline": {
                                                                                                        border: "1px solid rgba(76, 78, 100, 0.22)"
                                                                                                    }
                                                                                                },
                                                                                                name: "birth_date",
                                                                                                value: values.birth_date ? dayjs(values.birth_date) : null,
                                                                                                onChange: function(date) {
                                                                                                    var formattedDate = dayjs(date).isValid() ? dayjs(date).format("YYYY-MM-DD") : null;
                                                                                                    setFieldValue("birth_date", formattedDate);
                                                                                                }
                                                                                            })
                                                                                        })
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ _jsx("div", {
                                                                                    className: "col-xl-3 col-md-6",
                                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                        className: "mb-2 form-st-3 pb-1",
                                                                                        children: [
                                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                                className: "mb-1",
                                                                                                children: "อายุ"
                                                                                            }),
                                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                                type: "text",
                                                                                                name: "age",
                                                                                                className: "form-control",
                                                                                                placeholder: "กรอกอายุ",
                                                                                                value: values.age,
                                                                                                onChange: handleChange,
                                                                                                isInvalid: !!errors.age
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ _jsx("div", {
                                                                                    className: "col-xl-3 col-md-6",
                                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                        className: "mb-2 form-st-3 pb-1",
                                                                                        children: [
                                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                                className: "mb-1",
                                                                                                children: "เชื้อชาติ"
                                                                                            }),
                                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                                type: "text",
                                                                                                name: "ethnicity",
                                                                                                className: "form-control",
                                                                                                placeholder: "กรอกเชื้อชาติ",
                                                                                                value: values.ethnicity,
                                                                                                onChange: handleChange,
                                                                                                isInvalid: !!errors.ethnicity
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ _jsx("div", {
                                                                                    className: "col-xl-3 col-md-6",
                                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                        className: "mb-2 form-st-3 pb-1",
                                                                                        children: [
                                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                                className: "mb-1",
                                                                                                children: "สัญชาติ"
                                                                                            }),
                                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                                type: "text",
                                                                                                name: "nationality",
                                                                                                className: "form-control",
                                                                                                placeholder: "กรอกสัญชาติ",
                                                                                                value: values.nationality,
                                                                                                onChange: handleChange,
                                                                                                isInvalid: !!errors.nationality
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ _jsx("div", {
                                                                                    className: "col-xl-3 col-md-6",
                                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                        className: "mb-2 form-st-3 pb-1",
                                                                                        children: [
                                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                                className: "mb-1",
                                                                                                children: "สถานะสมรส"
                                                                                            }),
                                                                                            /*#__PURE__*/ _jsx(Select, {
                                                                                                as: "select",
                                                                                                name: "dim_mst_marital_status_id",
                                                                                                onChange: function(e) {
                                                                                                    setFieldValue("dim_mst_marital_status_id", e.value);
                                                                                                },
                                                                                                className: "w-100 select-st-1",
                                                                                                options: optionsMstMaritalStatus,
                                                                                                placeholder: "ระบุสถานะสมรส",
                                                                                                value: optionsMstMaritalStatus.filter(function(item) {
                                                                                                    return item.value === values.dim_mst_marital_status_id;
                                                                                                })
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ _jsx("div", {
                                                                                    className: "col-xl-3 col-md-6",
                                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                        className: "mb-2 form-st-3 pb-1",
                                                                                        children: [
                                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                                className: "mb-1",
                                                                                                children: "สถานะทางทหาร"
                                                                                            }),
                                                                                            /*#__PURE__*/ _jsx(Select, {
                                                                                                as: "select",
                                                                                                name: "dim_mst_military_status_id",
                                                                                                onChange: function(e) {
                                                                                                    setFieldValue("dim_mst_military_status_id", e.value);
                                                                                                },
                                                                                                className: "w-100 select-st-1",
                                                                                                options: optionsMstMilitaryStatus,
                                                                                                placeholder: "ระบุสถานะทางทหาร",
                                                                                                value: optionsMstMilitaryStatus.filter(function(item) {
                                                                                                    return item.value === values.dim_mst_military_status_id;
                                                                                                })
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "card card-st-3 mb-3",
                                        children: /*#__PURE__*/ _jsxs("div", {
                                            className: "card-body px-xl-3",
                                            children: [
                                                /*#__PURE__*/ _jsx("button", {
                                                    type: "button",
                                                    className: "btn w-100 text-start btn-collapse",
                                                    onClick: function() {
                                                        return setCardOpen2(!cardOpen2);
                                                    },
                                                    "aria-controls": "collapse2",
                                                    "aria-expanded": cardOpen2,
                                                    children: /*#__PURE__*/ _jsx("div", {
                                                        className: "tc-8  fs-18 fw-bold px-3",
                                                        children: "ข้อมูลการติดต่อ"
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx(Collapse, {
                                                    in: cardOpen2,
                                                    children: /*#__PURE__*/ _jsx("div", {
                                                        id: "collapse2",
                                                        children: /*#__PURE__*/ _jsx("div", {
                                                            children: /*#__PURE__*/ _jsx("div", {
                                                                className: "pt-3 px-3",
                                                                children: /*#__PURE__*/ _jsxs("div", {
                                                                    className: "row gx-xl-4",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "col-xl-12 col-md-12",
                                                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                className: "mb-2 form-st-3 pb-1",
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsxs(Form.Label, {
                                                                                        className: "mb-1",
                                                                                        children: [
                                                                                            "ที่อยู่",
                                                                                            " ",
                                                                                            /*#__PURE__*/ _jsx("span", {
                                                                                                className: "text-danger ms-1",
                                                                                                children: " *"
                                                                                            }),
                                                                                            " "
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsx(Form.Control, {
                                                                                        type: "text",
                                                                                        name: "address",
                                                                                        className: "form-control",
                                                                                        placeholder: "ที่อยู่",
                                                                                        value: values.address,
                                                                                        onChange: handleChange,
                                                                                        isInvalid: !!errors.address
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ _jsxs(ThailandAddressTypeahead, {
                                                                            value: address,
                                                                            onValueChange: function(val) {
                                                                                setAddress(val);
                                                                                setFieldValue("sub_district", val.subdistrict);
                                                                                setFieldValue("district", val.district);
                                                                                setFieldValue("province", val.province);
                                                                                setFieldValue("postal_code", val.postalCode);
                                                                            },
                                                                            children: [
                                                                                /*#__PURE__*/ _jsxs("div", {
                                                                                    className: "row gx-xl-4",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsx("div", {
                                                                                            className: "col-xl-6",
                                                                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                                className: "mb-2 form-st-3 pb-1",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                                                                        className: "mb-1",
                                                                                                        children: "แขวง/ตำบล"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx(ThailandAddressTypeahead.SubdistrictInput, {
                                                                                                        type: "text",
                                                                                                        className: "form-control ".concat(values.sub_district ? "" : !!errors.sub_district ? "is-invalid" : ""),
                                                                                                        placeholder: "กรอก แขวง/ตำบล",
                                                                                                        name: "sub_district",
                                                                                                        value: values.sub_district
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsx("div", {
                                                                                            className: "col-xl-6",
                                                                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                                className: "mb-2 form-st-3 pb-1",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                                                                        className: "mb-1",
                                                                                                        children: "อำเภอ/เขต"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx(ThailandAddressTypeahead.DistrictInput, {
                                                                                                        type: "text",
                                                                                                        className: "form-control ".concat(values.district ? "" : !!errors.district ? "is-invalid" : ""),
                                                                                                        placeholder: "กรอก อำเภอ/เขต",
                                                                                                        name: "district",
                                                                                                        value: values.district
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsx("div", {
                                                                                            className: "col-xl-6",
                                                                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                                className: "mb-2 form-st-3 pb-1",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                                                                        className: "mb-1",
                                                                                                        children: "จังหวัด"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx(ThailandAddressTypeahead.ProvinceInput, {
                                                                                                        type: "text",
                                                                                                        className: "form-control ".concat(values.province ? "" : !!errors.province ? "is-invalid" : ""),
                                                                                                        placeholder: "กรอกจังหวัด",
                                                                                                        name: "province",
                                                                                                        value: values.province
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsx("div", {
                                                                                            className: "col-xl-6",
                                                                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                                className: "mb-2 form-st-3 pb-1",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                                                                        className: "mb-1",
                                                                                                        children: "รหัสไปรษณีย์"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx(ThailandAddressTypeahead.PostalCodeInput, {
                                                                                                        type: "text",
                                                                                                        className: "form-control ".concat(values.postal_code ? "" : !!errors.postal_code ? "is-invalid" : ""),
                                                                                                        placeholder: "กรอกรหัสไปรษณีย์",
                                                                                                        name: "postal_code",
                                                                                                        value: values.postal_code
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ _jsx(ThailandAddressTypeahead.Suggestion, {
                                                                                    containerProps: {
                                                                                        className: "suggestion-container"
                                                                                    },
                                                                                    optionItemProps: {
                                                                                        className: "suggestion-option"
                                                                                    }
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "col-xxl-2 col-xl-3 col-md-6",
                                                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                className: "mb-2 form-st-3 pb-1",
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                                                        className: "mb-1",
                                                                                        children: "E-mail"
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsx(Form.Control, {
                                                                                        type: "text",
                                                                                        name: "email",
                                                                                        className: "form-control",
                                                                                        placeholder: "E-mail",
                                                                                        value: values.email,
                                                                                        onChange: handleChange,
                                                                                        isInvalid: !!errors.email
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "col-xxl-3 col-xl-3 col-md-6",
                                                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                className: "mb-2 form-st-3 pb-1",
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                                                        className: "mb-1",
                                                                                        children: "เบอร์โทรศัพท์"
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsx(Form.Control, {
                                                                                        type: "text",
                                                                                        name: "phone_number",
                                                                                        className: "form-control",
                                                                                        placeholder: "เบอร์โทรศัพท์",
                                                                                        value: values.phone_number,
                                                                                        onChange: handleChange,
                                                                                        isInvalid: !!errors.phone_number
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "col-xxl-2 col-xl-3 col-md-6",
                                                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                className: "mb-2 form-st-3 pb-1",
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                                                        className: "mb-1",
                                                                                        children: "Line"
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsx(Form.Control, {
                                                                                        type: "text",
                                                                                        name: "line",
                                                                                        className: "form-control",
                                                                                        placeholder: "Line",
                                                                                        value: values.line,
                                                                                        onChange: handleChange,
                                                                                        isInvalid: !!errors.line
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "col-xxl-3 col-xl-3 col-md-6",
                                                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                className: "mb-2 form-st-3 pb-1",
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                                                        className: "mb-1",
                                                                                        children: "Facebook"
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsx(Form.Control, {
                                                                                        type: "text",
                                                                                        name: "facebook",
                                                                                        className: "form-control",
                                                                                        placeholder: "Facebook",
                                                                                        value: values.facebook,
                                                                                        onChange: handleChange,
                                                                                        isInvalid: !!errors.facebook
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "col-xxl-2 col-xl-3 col-md-6",
                                                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                className: "mb-2 form-st-3 pb-1",
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                                                        className: "mb-1",
                                                                                        children: "Instagam"
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsx(Form.Control, {
                                                                                        type: "text",
                                                                                        name: "instagram",
                                                                                        className: "form-control",
                                                                                        placeholder: "instagram",
                                                                                        value: values.instagram,
                                                                                        onChange: handleChange,
                                                                                        isInvalid: !!errors.instagram
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "col-xl-4 col-md-6",
                                                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                className: "mb-2 form-st-3 pb-1",
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsxs(Form.Label, {
                                                                                        className: "mb-1",
                                                                                        children: [
                                                                                            "บุคคลติดต่อในกรณีฉุกเฉิน",
                                                                                            " "
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsx(Form.Control, {
                                                                                        type: "text",
                                                                                        name: "emergency_contact_person",
                                                                                        className: "form-control",
                                                                                        placeholder: "บุคคลติดต่อในกรณีฉุกเฉิน",
                                                                                        value: values.emergency_contact_person,
                                                                                        onChange: handleChange,
                                                                                        isInvalid: !!errors.emergency_contact_person
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "col-xl-4 col-md-6",
                                                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                className: "mb-2 form-st-3 pb-1",
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsxs(Form.Label, {
                                                                                        className: "mb-1",
                                                                                        children: [
                                                                                            "เบอร์โทรศัพท์",
                                                                                            " "
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsx(Form.Control, {
                                                                                        type: "text",
                                                                                        name: "emergency_phone_number",
                                                                                        className: "form-control",
                                                                                        placeholder: "เบอร์โทรศัพท์",
                                                                                        value: values.emergency_phone_number,
                                                                                        onChange: handleChange,
                                                                                        isInvalid: !!errors.emergency_phone_number
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "col-xl-4 col-md-6",
                                                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                className: "mb-2 form-st-3 pb-1",
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                                                        className: "mb-1",
                                                                                        children: "ความสัมพันธ์"
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsx(Select, {
                                                                                        as: "select",
                                                                                        name: "dim_mst_relationship_id",
                                                                                        onChange: function(e) {
                                                                                            setFieldValue("dim_mst_relationship_id", e.value);
                                                                                        },
                                                                                        className: "w-100 select-st-1",
                                                                                        options: optionsMstRelationship,
                                                                                        placeholder: "ระบุความสัมพันธ์",
                                                                                        value: optionsMstRelationship.filter(function(item) {
                                                                                            return item.value === values.dim_mst_relationship_id;
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "card card-st-3 mb-3",
                                        children: /*#__PURE__*/ _jsxs("div", {
                                            className: "card-body px-xl-3",
                                            children: [
                                                /*#__PURE__*/ _jsx("button", {
                                                    type: "button",
                                                    className: "btn w-100 text-start btn-collapse",
                                                    onClick: function() {
                                                        return setCardOpen3(!cardOpen3);
                                                    },
                                                    "aria-controls": "collapse3",
                                                    "aria-expanded": cardOpen3,
                                                    children: /*#__PURE__*/ _jsx("div", {
                                                        className: "tc-8  fs-18 fw-bold px-3",
                                                        children: "ข้อมูลการทำงาน"
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx(Collapse, {
                                                    in: cardOpen3,
                                                    children: /*#__PURE__*/ _jsx("div", {
                                                        id: "collapse3",
                                                        children: /*#__PURE__*/ _jsx("div", {
                                                            children: /*#__PURE__*/ _jsx("div", {
                                                                className: "pt-3 px-3",
                                                                children: /*#__PURE__*/ _jsxs("div", {
                                                                    className: "row gx-xl-4",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "col-xl-3 col-md-6",
                                                                            children: /*#__PURE__*/ _jsx(Form.Group, {
                                                                                className: "mt-[12px]",
                                                                                children: /*#__PURE__*/ _jsx(LocalizationProvider, {
                                                                                    dateAdapter: AdapterDayjs,
                                                                                    className: "h-[40px]",
                                                                                    children: /*#__PURE__*/ _jsx(DatePicker, {
                                                                                        format: "DD/MM/YYYY",
                                                                                        slotProps: {
                                                                                            textField: {
                                                                                                InputLabelProps: {
                                                                                                    shrink: true
                                                                                                },
                                                                                                error: !!errors.start_date
                                                                                            }
                                                                                        },
                                                                                        label: "วันที่เริ่มทำงาน",
                                                                                        className: "h-[40px] w-full ",
                                                                                        sx: {
                                                                                            ".MuiInputBase-formControl": {
                                                                                                height: "53px",
                                                                                                borderRadius: "8px"
                                                                                            },
                                                                                            ".MuiFormLabel-root": {
                                                                                                fontFamily: "Sarabun"
                                                                                            },
                                                                                            ".MuiOutlinedInput-notchedOutline": {
                                                                                                border: "1px solid rgba(76, 78, 100, 0.22)"
                                                                                            }
                                                                                        },
                                                                                        name: "start_datee",
                                                                                        value: values.start_date ? dayjs(values.start_date) : null,
                                                                                        onChange: function(date) {
                                                                                            var formattedDate = dayjs(date).isValid() ? dayjs(date).format("YYYY-MM-DD") : null;
                                                                                            setFieldValue("start_date", formattedDate);
                                                                                        }
                                                                                    })
                                                                                })
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "col-xl-3 col-md-6",
                                                                            children: /*#__PURE__*/ _jsx(Form.Group, {
                                                                                className: "mt-[12px]" /* className="mb-3 form-st-3 pb-1" */ ,
                                                                                children: /*#__PURE__*/ _jsx(LocalizationProvider, {
                                                                                    dateAdapter: AdapterDayjs,
                                                                                    className: "h-[40px]",
                                                                                    children: /*#__PURE__*/ _jsx(DatePicker, {
                                                                                        format: "DD/MM/YYYY",
                                                                                        slotProps: {
                                                                                            textField: {
                                                                                                InputLabelProps: {
                                                                                                    shrink: true
                                                                                                },
                                                                                                error: !!errors.end_date
                                                                                            }
                                                                                        },
                                                                                        label: "วันที่สิ้นสุด",
                                                                                        className: "h-[40px] w-full ",
                                                                                        sx: {
                                                                                            ".MuiInputBase-formControl": {
                                                                                                height: "53px",
                                                                                                borderRadius: "8px"
                                                                                            },
                                                                                            ".MuiFormLabel-root": {
                                                                                                fontFamily: "Sarabun"
                                                                                            },
                                                                                            ".MuiOutlinedInput-notchedOutline": {
                                                                                                border: "1px solid rgba(76, 78, 100, 0.22)"
                                                                                            }
                                                                                        },
                                                                                        name: "end_date",
                                                                                        value: values.end_date ? dayjs(values.end_date) : null,
                                                                                        onChange: function(date) {
                                                                                            var formattedDate = dayjs(date).isValid() ? dayjs(date).format("YYYY-MM-DD") : null;
                                                                                            setFieldValue("end_date", formattedDate);
                                                                                        }
                                                                                    })
                                                                                })
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "col-xl-3 col-md-6",
                                                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                className: "mb-2 form-st-3 pb-1",
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                                                        className: "mb-1",
                                                                                        children: "ประเภทพนักงาน"
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsx(Select, {
                                                                                        as: "select",
                                                                                        name: "dim_mst_employee_type_id",
                                                                                        onChange: function(e) {
                                                                                            setFieldValue("dim_mst_employee_type_id", e.value);
                                                                                        },
                                                                                        className: "w-100 select-st-1",
                                                                                        options: optionsMstEmployeeType,
                                                                                        placeholder: "ประเภทพนักงาน",
                                                                                        value: optionsMstEmployeeType.filter(function(item) {
                                                                                            return item.value === values.dim_mst_employee_type_id;
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "col-xl-3 col-md-6"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "col-xl-3 col-md-6",
                                                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                className: "mb-2 form-st-3 pb-1",
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                                                        className: "mb-1",
                                                                                        children: "แผนก"
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsx(Select, {
                                                                                        as: "select",
                                                                                        name: "dim_mst_department_id",
                                                                                        onChange: function(e) {
                                                                                            setFieldValue("dim_mst_department_id", e.value);
                                                                                        },
                                                                                        className: "w-100 select-st-1",
                                                                                        options: optionsMstDepartment,
                                                                                        placeholder: "แผนก",
                                                                                        value: optionsMstDepartment.filter(function(item) {
                                                                                            return item.value === values.dim_mst_department_id;
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "col-xl-3 col-md-6",
                                                                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                className: "mb-2 form-st-3 pb-1",
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                                                        className: "mb-1",
                                                                                        children: "ตำแหน่ง"
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsx(Select, {
                                                                                        as: "select",
                                                                                        name: "dim_mst_position_id",
                                                                                        onChange: function(e) {
                                                                                            setFieldValue("dim_mst_position_id", e.value);
                                                                                        },
                                                                                        className: "w-100 select-st-1",
                                                                                        options: optionsMstPosition,
                                                                                        placeholder: "ตำแหน่ง",
                                                                                        value: optionsMstPosition.filter(function(item) {
                                                                                            return item.value === values.dim_mst_position_id;
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "col-xl-6 col-md-12 align-self-center",
                                                                            children: /*#__PURE__*/ _jsx(Form.Check, {
                                                                                name: "is_register_social_security",
                                                                                type: "checkbox",
                                                                                id: "socialSecurity",
                                                                                label: "ขึ้นทะเบียนประกันสังคม",
                                                                                className: "form-check-st-1",
                                                                                checked: values.is_register_social_security == 1,
                                                                                onChange: function(e) {
                                                                                    if (e.target.checked === true) {
                                                                                        setFieldValue("is_register_social_security", 1);
                                                                                    } else {
                                                                                        setFieldValue("is_register_social_security", 0);
                                                                                    }
                                                                                }
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "card card-st-3 mb-3",
                                        children: /*#__PURE__*/ _jsxs("div", {
                                            className: "card-body px-xl-3",
                                            children: [
                                                /*#__PURE__*/ _jsx("button", {
                                                    type: "button",
                                                    className: "btn w-100 text-start btn-collapse",
                                                    onClick: function() {
                                                        return setCardOpen4(!cardOpen4);
                                                    },
                                                    "aria-controls": "collapse4",
                                                    "aria-expanded": cardOpen4,
                                                    children: /*#__PURE__*/ _jsx("div", {
                                                        className: "tc-8  fs-18 fw-bold px-3",
                                                        children: "ช่องทางการรับเงินเดือน"
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx(Collapse, {
                                                    in: cardOpen4,
                                                    children: /*#__PURE__*/ _jsx("div", {
                                                        id: "collapse4",
                                                        children: /*#__PURE__*/ _jsx("div", {
                                                            children: /*#__PURE__*/ _jsxs("div", {
                                                                className: "pt-3 px-3",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx(Form.Label, {
                                                                        className: "mb-2  tc-10",
                                                                        children: "ช่องทางรับเงินเดือน"
                                                                    }),
                                                                    [
                                                                        "radio"
                                                                    ].map(function(type) {
                                                                        return /*#__PURE__*/ _jsxs("div", {
                                                                            className: "mb-3",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx(Form.Check, {
                                                                                    inline: true,
                                                                                    label: "บัญชีธนาคาร",
                                                                                    name: "is_bank_account",
                                                                                    type: type,
                                                                                    id: "mn-".concat(type, "-21"),
                                                                                    className: "form-check-st-2 tc-7",
                                                                                    checked: values.is_bank_account == 1,
                                                                                    onChange: function(e) {
                                                                                        setFieldValue("is_bank_account", 1);
                                                                                    }
                                                                                }),
                                                                                /*#__PURE__*/ _jsx(Form.Check, {
                                                                                    inline: true,
                                                                                    label: "เงินสด",
                                                                                    name: "is_bank_account",
                                                                                    type: type,
                                                                                    id: "mn-".concat(type, "-22"),
                                                                                    className: "form-check-st-2 tc-7",
                                                                                    checked: values.is_bank_account == 0,
                                                                                    onChange: function(e) {
                                                                                        setFieldValue("is_bank_account", 0);
                                                                                    }
                                                                                })
                                                                            ]
                                                                        }, "inline-".concat(type));
                                                                    }),
                                                                    values.is_bank_account == 1 ? /*#__PURE__*/ _jsxs("div", {
                                                                        className: "row gx-xl-4",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                className: "col-xl-4 col-md-6",
                                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                    className: "mb-2 form-st-3 pb-1",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                                            className: "mb-1",
                                                                                            children: "ธนาคาร"
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsx(Select, {
                                                                                            as: "select",
                                                                                            name: "dim_mst_bank_id",
                                                                                            onChange: function(e) {
                                                                                                setFieldValue("dim_mst_bank_id", e.value);
                                                                                            },
                                                                                            className: "w-100 select-st-1",
                                                                                            options: optionsMstBank,
                                                                                            placeholder: "ธนาคาร",
                                                                                            value: optionsMstBank.filter(function(item) {
                                                                                                return item.value === values.dim_mst_bank_id;
                                                                                            })
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                className: "col-xl-4 col-md-6",
                                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                    className: "mb-2 form-st-3 pb-1",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                                            className: "mb-1",
                                                                                            children: "ประเภทบัญชี"
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsx(Select, {
                                                                                            as: "select",
                                                                                            name: "dim_mst_bank_account_type_id",
                                                                                            onChange: function(e) {
                                                                                                setFieldValue("dim_mst_bank_account_type_id", e.value);
                                                                                            },
                                                                                            className: "w-100 select-st-1",
                                                                                            options: optionsMstBankAccountType,
                                                                                            placeholder: "ประเภทบัญชี",
                                                                                            value: optionsMstBankAccountType.filter(function(item) {
                                                                                                return item.value === values.dim_mst_bank_account_type_id;
                                                                                            })
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                className: "col-xl-4 col-md-6",
                                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                    className: "mb-2 form-st-3 pb-1",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                                            className: "mb-1",
                                                                                            children: "ชื่อบัญชี"
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                                            type: "text",
                                                                                            name: "bank_account_name",
                                                                                            className: "form-control",
                                                                                            placeholder: "ชื่อบัญชี",
                                                                                            value: values.bank_account_name,
                                                                                            onChange: handleChange,
                                                                                            isInvalid: !!errors.bank_account_name
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                className: "col-xl-4 col-md-6",
                                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                    className: "mb-2 form-st-3 pb-1",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                                            className: "mb-1",
                                                                                            children: "เลขบัญชี"
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                                            type: "text",
                                                                                            name: "bank_account_number",
                                                                                            className: "form-control",
                                                                                            placeholder: "เลขบัญชี",
                                                                                            value: values.bank_account_number,
                                                                                            onChange: handleChange,
                                                                                            isInvalid: !!errors.bank_account_number
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                className: "col-xl-4 col-md-6",
                                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                    className: "mb-2 form-st-3 pb-1",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                                            className: "mb-1",
                                                                                            children: "ชื่อสาขา (ถ้ามี)"
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                                            type: "text",
                                                                                            name: "bank_account_branch_name",
                                                                                            className: "form-control",
                                                                                            placeholder: "กรอกชื่อสาขา",
                                                                                            value: values.bank_account_branch_name,
                                                                                            onChange: handleChange,
                                                                                            isInvalid: !!errors.bank_account_branch_name
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                className: "col-xl-4 col-md-6",
                                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                                    className: "mb-2 form-st-3 pb-1",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                                            className: "mb-1",
                                                                                            children: "เลขที่สาขา (ถ้ามี)"
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                                            type: "text",
                                                                                            name: "bank_account_branch_number",
                                                                                            className: "form-control",
                                                                                            placeholder: "กรอกเลขที่สาขา",
                                                                                            value: values.bank_account_branch_number,
                                                                                            onChange: handleChange,
                                                                                            isInvalid: !!errors.bank_account_branch_number
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            })
                                                                        ]
                                                                    }) : ""
                                                                ]
                                                            })
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "card card-st-3 mb-3",
                                        children: /*#__PURE__*/ _jsxs("div", {
                                            className: "card-body px-xl-3",
                                            children: [
                                                /*#__PURE__*/ _jsx("button", {
                                                    type: "button",
                                                    className: "btn w-100 text-start btn-collapse",
                                                    onClick: function() {
                                                        return setCardOpen5(!cardOpen5);
                                                    },
                                                    "aria-controls": "collapse5",
                                                    "aria-expanded": cardOpen5,
                                                    children: /*#__PURE__*/ _jsx("div", {
                                                        className: "tc-8  fs-18 fw-bold px-3 ",
                                                        children: "เอกสารแนบ"
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx(Collapse, {
                                                    in: cardOpen5,
                                                    children: /*#__PURE__*/ _jsxs("div", {
                                                        id: "collapse5",
                                                        className: "pt-4",
                                                        children: [
                                                            documents.map(function(item, index) {
                                                                return /*#__PURE__*/ _jsx(Fileupload, {
                                                                    setFieldValue: setFieldValue,
                                                                    values: values,
                                                                    item: item,
                                                                    index: index,
                                                                    setDocuments: setDocuments,
                                                                    optionsMstEmployeeDoc: optionsMstEmployeeDoc,
                                                                    ondeleteDocument: function(id) {
                                                                        deleteDocument(id);
                                                                    }
                                                                }, index);
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "px-3 py-4",
                                                                children: /*#__PURE__*/ _jsx("button", {
                                                                    type: "button",
                                                                    className: "btn btn-st-4",
                                                                    onClick: addDocument,
                                                                    children: "เพิ่มเอกสาร"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            empID ? /*#__PURE__*/ _jsx("div", {
                                className: "card card-st-3 mb-3",
                                children: /*#__PURE__*/ _jsx("div", {
                                    className: "card-body px-xl-3 text-end",
                                    children: /*#__PURE__*/ _jsx("button", {
                                        type: "button",
                                        className: "btn  btn-st-3",
                                        onClick: function() {
                                            return setModalconfirmcancelemp(true);
                                        },
                                        style: {
                                            background: "#F95057",
                                            borderColor: "#F95057"
                                        },
                                        children: "พนักงานลาออก"
                                    })
                                })
                            }) : "",
                            /*#__PURE__*/ _jsx("div", {
                                className: "text-end pb-4 pe-3",
                                children: formdisabled === true ? /*#__PURE__*/ _jsx(Button, {
                                    type: "button",
                                    className: "btn-st-3 mx-3",
                                    onClick: function(e) {
                                        setFormdisabled(false);
                                    },
                                    children: "แก้ไข"
                                }) : /*#__PURE__*/ _jsxs("div", {
                                    className: "text-end pt-3 btn-group-control",
                                    children: [
                                        /*#__PURE__*/ _jsx(Button, {
                                            type: "button",
                                            className: "btn-st-6 me-3 btn",
                                            onClick: function() {
                                                return setModalcancel(true);
                                            },
                                            children: "ยกเลิก"
                                        }),
                                        /*#__PURE__*/ _jsx(Button, {
                                            type: "submit",
                                            className: "btn-st-3 ",
                                            children: "บันทึก"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx(ConfirmCancelempModal, {
                                show: modalconfirmcancelemp,
                                onHide: function() {
                                    return setModalconfirmcancelemp(false);
                                },
                                onSuccess: function() {
                                    return setModalsuccess(true);
                                },
                                empID: empID,
                                setTextsuccess: setTextsuccess,
                                setFieldValue: setFieldValue
                            })
                        ]
                    });
                }
            }),
            /*#__PURE__*/ _jsx(ConfirmCancelModal, {
                show: modalcancel,
                onHide: function() {
                    return setModalcancel(false);
                }
            }),
            /*#__PURE__*/ _jsx(SuccessModal, {
                show: modalsuccess,
                onHide: function() {
                    return setModalsuccess(false);
                },
                textsuccess: textsuccess,
                navigate: navigate,
                direction: empID ? null : "/emps"
            })
        ]
    });
}
var Imageupload = function(_param) {
    var isUpdate = _param.isUpdate, props = _object_without_properties(_param, [
        "isUpdate"
    ]);
    var _useState = _sliced_to_array(useState(false), 2), imgData = _useState[0], setImgData = _useState[1];
    var handlePreviewimage = function(e) {
        if (e.target.files[0]) {
            var reader = new FileReader();
            reader.addEventListener("load", function() {
                setImgData(reader.result);
                props.setFieldValue("img_file", reader.result);
                if (isUpdate) {
                    props.setFieldValue("is_update_img_file", true);
                }
            });
            reader.readAsDataURL(e.target.files[0]);
        }
    };
    useEffect(function() {
        setImgData(props.values.img_path ? getFullUrlPath(props.values.img_path) : false);
    }, [
        props.values.img_path
    ]);
    return /*#__PURE__*/ _jsx("div", {
        className: "px-3",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "d-flex align-items-center mb-4 mt-3 ",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "bx-upload s2",
                    children: imgData ? /*#__PURE__*/ _jsx("img", {
                        src: imgData
                    }) : /*#__PURE__*/ _jsx("div", {
                        className: "preimg"
                    })
                }),
                /*#__PURE__*/ _jsx("input", {
                    type: "file",
                    name: "",
                    className: "fileUpload hide-input",
                    id: "fileUpload",
                    accept: "image/*",
                    onChange: function(e) {
                        handlePreviewimage(e);
                    }
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "flex-fill ms-3",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "mb-3",
                            children: [
                                /*#__PURE__*/ _jsx("button", {
                                    type: "button",
                                    className: "btn btn-st-4 btn-upload me-3",
                                    onClick: function(e) {
                                        return document.getElementById("fileUpload").click();
                                    },
                                    children: "อัพโหลดรูปภาพ"
                                }),
                                /*#__PURE__*/ _jsx("button", {
                                    type: "button",
                                    className: "btn btn-st-2 btn-remove-image",
                                    onClick: function(e) {
                                        setImgData(false);
                                        props.setFieldValue("img_file", "");
                                        if (isUpdate) {
                                            props.setFieldValue("is_update_img_file", true);
                                        }
                                    },
                                    children: "ลบ"
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "tc-7 fs-12",
                            children: "อัพโหลดไฟล์ JPG, GIF or PNG. ขนาดไม่เกิน 800K"
                        })
                    ]
                })
            ]
        })
    });
};
var Fileupload = function(_param) {
    var item = _param.item, index = _param.index, setFieldValue = _param.setFieldValue, values = _param.values, ondeleteDocument = _param.ondeleteDocument, setDocuments = _param.setDocuments, optionsMstEmployeeDoc = _param.optionsMstEmployeeDoc, props = _object_without_properties(_param, [
        "item",
        "index",
        "setFieldValue",
        "values",
        "ondeleteDocument",
        "setDocuments",
        "optionsMstEmployeeDoc"
    ]);
    var _useState = _sliced_to_array(useState(false), 2), filedata = _useState[0], setFiledata = _useState[1];
    var files = item.docFile.split(".");
    var handlePreviewFile = function(e, itemIndex) {
        if (e.target.files[0]) {
            var reader = new FileReader();
            var file = e.target.files[0].name.split(".");
            var blobUrl = URL.createObjectURL(e.target.files[0]);
            reader.addEventListener("load", function() {
                setDocuments(function(prev) {
                    return prev.map(function(el) {
                        return el.id == item.id ? _object_spread_props(_object_spread({}, el), {
                            docFile: e.target.files[0].name,
                            docFileType: file[1],
                            docFileData: reader.result,
                            docUrl: blobUrl
                        }) : el;
                    });
                });
            });
            reader.readAsDataURL(e.target.files[0]);
        }
    };
    useEffect(function() {
        setFiledata(values.img_path);
    }, [
        values.img_path
    ]);
    return /*#__PURE__*/ _jsx("div", {
        className: "px-3",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "row gx-xl-4 align-items-center",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "col-auto",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "fs-24 fw-bold tc-8",
                        children: [
                            index + 1,
                            "."
                        ]
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "col-xxl-2 col-xl-3 col-md-4 ",
                    children: [
                        /*#__PURE__*/ _jsxs(Form.Group, {
                            className: "mb-2 form-st-3 pb-1",
                            children: [
                                /*#__PURE__*/ _jsx(Form.Label, {
                                    className: "mb-1",
                                    children: "เอกสาร"
                                }),
                                /*#__PURE__*/ _jsx(Select, {
                                    as: "select",
                                    name: "doc",
                                    onChange: function(e) {
                                        setDocuments(function(prev) {
                                            return prev.map(function(el) {
                                                return el.id == item.id ? _object_spread_props(_object_spread({}, el), {
                                                    docType: e.value
                                                }) : el;
                                            });
                                        });
                                    },
                                    className: "w-100 select-st-1",
                                    options: optionsMstEmployeeDoc,
                                    placeholder: "",
                                    value: optionsMstEmployeeDoc.filter(function(d) {
                                        return d.value == item.docType;
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("input", {
                            type: "file",
                            name: "",
                            className: "fileUpload hide-input",
                            id: "fileUpload".concat(item.id),
                            accept: ".pdf",
                            onChange: function(e) {
                                handlePreviewFile(e);
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "col-auto",
                    children: /*#__PURE__*/ _jsx("div", {
                        style: {
                            width: "180px"
                        },
                        children: item.docFile != "" ? /*#__PURE__*/ _jsx("a", {
                            href: "".concat(item.docUrl),
                            target: "_blank",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "docfile",
                                children: [
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "icon ".concat(files[1])
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "name fs-18",
                                        children: files[0]
                                    })
                                ]
                            })
                        }) : /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            className: "btn  btn-upload-file",
                            onClick: function(e) {
                                return document.getElementById("fileUpload".concat(item.id)).click();
                            },
                            children: "อัปโหลดรูปภาพ"
                        })
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "col-auto",
                    children: /*#__PURE__*/ _jsx("button", {
                        type: "button",
                        className: "btn  btn-delete-file ",
                        onClick: function(e) {
                            return ondeleteDocument(item.id);
                        }
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "col"
                })
            ]
        })
    });
};
function getCurrentDate() {
    var separator = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", dateb = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new Date();
    var newDate = dateb;
    var date = newDate.getDate();
    var month = newDate.getMonth() + 1;
    var year = newDate.getFullYear();
    return "".concat(date).concat(separator).concat(month < 10 ? "0".concat(month) : "".concat(month)).concat(separator).concat(year);
}
function ConfirmCancelempModal(props) {
    var setTextsuccess = props.setTextsuccess, empID = props.empID, onSuccess = props.onSuccess, setFieldValue = props.setFieldValue, rest = _object_without_properties(props, [
        "setTextsuccess",
        "empID",
        "onSuccess",
        "setFieldValue"
    ]);
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var dispatch = useAppDispatch();
    var _useState = _sliced_to_array(useState(""), 2), startDate = _useState[0], setStartDate = _useState[1];
    var schema = yup.object().shape({
        end_date: yup.string().required()
    });
    var updateNewAlldernowEmpReducer = useAppSelector(function(state) {
        return state.updateNewAlldernowEmpReducer;
    });
    useEffect(function() {
        setIsLoading(updateNewAlldernowEmpReducer.isFetching);
        if (updateNewAlldernowEmpReducer.data && !updateNewAlldernowEmpReducer.isError) {
            props.setTextsuccess("ทำรายการสำเร็จ");
            props.onHide();
            props.onSuccess();
            dispatch(getNewAlldernowEmpById(empID, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        }
    }, [
        updateNewAlldernowEmpReducer
    ]);
    return /*#__PURE__*/ _jsx(Modal, _object_spread_props(_object_spread({}, rest), {
        size: "md",
        centered: true,
        children: /*#__PURE__*/ _jsx(Modal.Body, {
            children: /*#__PURE__*/ _jsx("div", {
                className: "px-3 py-4",
                children: /*#__PURE__*/ _jsx(Formik, {
                    enableReinitialize: true,
                    initialValues: {
                        end_date: ""
                    },
                    validationSchema: schema,
                    onSubmit: function() {
                        var _ref = _async_to_generator(function(values) {
                            var formdataPayload, key, value;
                            return _ts_generator(this, function(_state) {
                                // props.setFieldValue("empStatus", 3);
                                // props.setTextsuccess("ทำรายการสำเร็จ");
                                // props.onHide();
                                // props.onSuccess();
                                formdataPayload = new FormData();
                                for(var key in values){
                                    if (Object.hasOwnProperty.call(values, key)) {
                                        value = values[key];
                                        if (value !== undefined && value !== "") {
                                            formdataPayload.append(key, value);
                                        }
                                    }
                                }
                                // for (let pair of formdataPayload.entries()) {
                                //   console.log(`${pair[0]}, ${pair[1].name ?? pair[1]}`);
                                // }
                                dispatch(updateNewAlldernowEmp(empID, formdataPayload, {
                                    modalObj: modalObj,
                                    setModalObj: setModalObj
                                }));
                                return [
                                    2
                                ];
                            });
                        });
                        return function(values) {
                            return _ref.apply(this, arguments);
                        };
                    }(),
                    children: function(param) {
                        var handleSubmit = param.handleSubmit, handleChange = param.handleChange, touched = param.touched, errors = param.errors, values = param.values, setFieldValue = param.setFieldValue, isInvalid = param.isInvalid, isValid = param.isValid;
                        return /*#__PURE__*/ _jsx(Form, {
                            noValidate: true,
                            onSubmit: handleSubmit,
                            children: /*#__PURE__*/ _jsxs("div", {
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        children: /*#__PURE__*/ _jsx("div", {
                                            className: "text-center fs-22 tc-7 mb-4",
                                            children: "คุณยืนยันการลาออกใช่หรือไม่"
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Form.Group, {
                                        className: "mt-[12px]" /* className="mb-3 form-st-3 pb-1" */ ,
                                        children: /*#__PURE__*/ _jsx(LocalizationProvider, {
                                            dateAdapter: AdapterDayjs,
                                            className: "h-[40px]",
                                            children: /*#__PURE__*/ _jsx(DatePicker, {
                                                format: "DD/MM/YYYY",
                                                slotProps: {
                                                    textField: {
                                                        InputLabelProps: {
                                                            shrink: true
                                                        },
                                                        error: !!errors.end_date
                                                    }
                                                },
                                                label: "วันที่ลาออก",
                                                className: "h-[40px] w-full ",
                                                sx: {
                                                    ".MuiInputBase-formControl": {
                                                        height: "53px",
                                                        borderRadius: "8px"
                                                    },
                                                    ".MuiFormLabel-root": {
                                                        fontFamily: "Sarabun"
                                                    },
                                                    ".MuiOutlinedInput-notchedOutline": {
                                                        border: "1px solid rgba(76, 78, 100, 0.22)"
                                                    }
                                                },
                                                name: "end_date",
                                                value: values.end_date ? dayjs(values.end_date) : null,
                                                onChange: function(date) {
                                                    var formattedDate = dayjs(date).isValid() ? dayjs(date).format("YYYY-MM-DD") : null;
                                                    setFieldValue("end_date", formattedDate);
                                                }
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "text-center pt-4 mt-3  btn-group-control",
                                        children: [
                                            /*#__PURE__*/ _jsx(Button, {
                                                type: "button",
                                                className: "btn-st-6 mx-3 ",
                                                style: {
                                                    width: "150px"
                                                },
                                                onClick: props.onHide,
                                                children: "ไม่ยกเลิก"
                                            }),
                                            /*#__PURE__*/ _jsx(Button, {
                                                type: "submit",
                                                className: "btn btn-st-3 mx-3 text-decoration-none",
                                                style: {
                                                    width: "150px"
                                                },
                                                children: "ยืนยันการลาออก"
                                            })
                                        ]
                                    })
                                ]
                            })
                        });
                    }
                })
            })
        })
    }));
}
function ConfirmCancelModal(props) {
    return /*#__PURE__*/ _jsx(Modal, _object_spread_props(_object_spread({}, props), {
        size: "md",
        centered: true,
        children: /*#__PURE__*/ _jsx(Modal.Body, {
            children: /*#__PURE__*/ _jsx("div", {
                className: "px-3 py-4",
                children: /*#__PURE__*/ _jsxs("div", {
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "text-center fs-22 tc-7 mb-2",
                                    children: "คุณต้องการยกเลิก"
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "text-center fs-22 tc-7",
                                    children: "การสร้างรายการนี้ใช่หรือไม่"
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "text-center pt-4 mt-3  btn-group-control",
                            children: [
                                /*#__PURE__*/ _jsx(Link, {
                                    to: "/emps",
                                    className: "btn btn-st-3 mx-3 text-decoration-none",
                                    style: {
                                        width: "100px"
                                    },
                                    children: "ใช่"
                                }),
                                /*#__PURE__*/ _jsx(Button, {
                                    type: "button",
                                    className: "btn-st-6 mx-3 ",
                                    style: {
                                        width: "100px"
                                    },
                                    onClick: props.onHide,
                                    children: "ไม่ใช่"
                                })
                            ]
                        })
                    ]
                })
            })
        })
    }));
}
function SuccessModal(_param) {
    var navigate = _param.navigate, show = _param.show, direction = _param.direction, props = _object_without_properties(_param, [
        "navigate",
        "show",
        "direction"
    ]);
    var handleCloseAndNavigate = function() {
        props.onHide();
        if (direction) {
            navigate(direction);
        }
    };
    return /*#__PURE__*/ _jsx(Modal, _object_spread_props(_object_spread({}, props), {
        size: "sm",
        centered: true,
        show: show,
        onHide: handleCloseAndNavigate,
        children: /*#__PURE__*/ _jsx(Modal.Body, {
            children: /*#__PURE__*/ _jsxs("div", {
                className: "px-3 py-4",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center mb-4",
                        children: /*#__PURE__*/ _jsxs("svg", {
                            width: "84",
                            height: "83",
                            viewBox: "0 0 84 83",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            className: "mx-auto",
                            children: [
                                /*#__PURE__*/ _jsx("circle", {
                                    cx: "42",
                                    cy: "41.5",
                                    r: "41.5",
                                    fill: "#2DC76D"
                                }),
                                /*#__PURE__*/ _jsx("path", {
                                    d: "M56.0123 30.9902L36.7444 50.2581L27.9863 41.5",
                                    stroke: "white",
                                    strokeWidth: "5",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center fs-18 tc-7",
                        children: props.textsuccess
                    })
                ]
            })
        })
    }));
}
